import {
  deleteMethod,
  getMethod,
  patchMethod,
  postMethod,
} from '../../api/methods'
import API_ROUTES from '../../api/routes'

const {
  GET_BRAND,
  GET_ALL_BRAND,
  GET_IMAGE_FILE,
  DELETE_IMAGE_FILES,
  ADD_BRAND,
  SEARCH_BRAND,
  ALL_PRODUCT_SERIES,
} = API_ROUTES

const getCatalogueApi = async ({ id }) => {
  const response = await getMethod(GET_BRAND({ id }))
  return response?.data
}

const getBrandListApi = async ({ params }) => {
  const response = await getMethod(GET_ALL_BRAND({ params }))
  return response?.data
}

const getImageFileApi = async ({ params, payload }) => {
  const response = await postMethod(GET_IMAGE_FILE({ params }), payload)
  return response?.data
}
const deleteImageFileApi = async ({ params }) => {
  const response = await deleteMethod(GET_IMAGE_FILE({ params }))
  return response?.data
}
const deleteMultipleImageApi = async ({ params }) => {
  const response = await deleteMethod(DELETE_IMAGE_FILES({ params }))
  return response?.data
}
const addBrandApi = async ({ params }) => {
  const response = await postMethod(ADD_BRAND({ params }))
  return response?.data
}
const updateBrandApi = async ({ params }) => {
  const response = await patchMethod(ADD_BRAND({ params }))
  return response?.data
}
const searchBrandApi = async ({ params }) => {
  const response = await getMethod(SEARCH_BRAND({ params }))
  return response?.data
}

const getAllProductSeriesApi = async ({ params }) => {
  const response = await getMethod(ALL_PRODUCT_SERIES({ params }))
  return response?.data
}

export {
  getCatalogueApi,
  getBrandListApi,
  getImageFileApi,
  addBrandApi,
  searchBrandApi,
  deleteImageFileApi,
  deleteMultipleImageApi,
  updateBrandApi,
  getAllProductSeriesApi,
}
